import { store } from './store.js';

export const ROUTE_CONFIG = {
  '/': {
    title: 'Dịch Vụ Vệ Sinh Máy Lạnh Chuyên Nghiệp | Giá Từ 150K',
    description: 'Dịch vụ vệ sinh máy lạnh chuyên nghiệp tại TP.HCM, giá từ 150.000đ. Đội ngũ kỹ thuật viên 10+ năm kinh nghiệm, mát lạnh tức thì, kiểm tra gas miễn phí.',
    sectionId: 'hero',
    canonical: 'https://thodienxanh.com/'
  },
  '/bang-gia': {
    title: 'Bảng Giá Vệ Sinh Máy Lạnh Mới Nhất 2026 | Chỉ Từ 150K',
    description: 'Báo giá vệ sinh máy lạnh treo tường, âm trần, tủ đứng, multi trọn gói không phát sinh. Giảm 10% khi đặt từ 2 bộ.',
    sectionId: 'bang-gia',
    canonical: 'https://thodienxanh.com/bang-gia'
  },
  '/loi-ich': {
    title: 'Tại Sao Cần Vệ Sinh Máy Lạnh Định Kỳ? | Tiết Kiệm 30% Điện',
    description: 'Tìm hiểu lợi ích của việc vệ sinh máy lạnh: tiết kiệm 5-30% điện năng, diệt 99% vi khuẩn, tăng tuổi thọ máy nén.',
    sectionId: 'loi-ich',
    canonical: 'https://thodienxanh.com/loi-ich'
  },
  '/quy-trinh': {
    title: 'Quy Trình 6 Bước Vệ Sinh Máy Lạnh Chuẩn Hãng | Thợ Điện Xanh',
    description: 'Quy trình vệ sinh máy lạnh 6 bước chuyên sâu chuẩn hãng Daikin, Panasonic: kiểm tra, tháo vỏ, xịt rửa áp lực cao, khử khuẩn nano bạc.',
    sectionId: 'quy-trinh',
    canonical: 'https://thodienxanh.com/quy-trinh'
  },
  '/ve-chung-toi': {
    title: 'Về Chúng Tôi — Đội Ngũ Kỹ Thuật Viên 10+ Năm Kinh Nghiệm | Thợ Điện Xanh',
    description: 'Thợ Điện Xanh với hơn 10 năm kinh nghiệm, phục vụ 2.800+ khách hàng tại TP.HCM. Quy trình chuẩn hãng, hóa chất sinh học an toàn.',
    sectionId: 'about',
    canonical: 'https://thodienxanh.com/ve-chung-toi'
  },
  '/blog': {
    title: 'Cẩm Nang & Kiến Thức Về Máy Lạnh | Thợ Điện Xanh Blog',
    description: 'Tổng hợp mẹo sử dụng máy lạnh tiết kiệm điện, cách tự vệ sinh lưới lọc tại nhà, phát hiện thiếu gas và xử lý máy lạnh chảy nước.',
    action: 'open_blog_listing',
    canonical: 'https://thodienxanh.com/blog'
  },
  '/faq': {
    title: 'Câu Hỏi Thường Gặp Về Dịch Vụ Vệ Sinh Máy Lạnh | FAQ',
    description: 'Giải đáp thắc mắc: bao lâu nên vệ sinh máy lạnh một lần, vệ sinh mất bao lâu, có cần nạp thêm gas không và chính sách bảo hành.',
    sectionId: 'faq',
    canonical: 'https://thodienxanh.com/faq'
  },
  '/lien-he': {
    title: 'Liên Hệ Đặt Lịch Vệ Sinh Máy Lạnh Tận Nơi | Hotline 0909.123.456',
    description: 'Liên hệ đội ngũ kỹ thuật viên Thợ Điện Xanh tại TP.HCM. Có mặt sau 30 phút, phục vụ tất cả các quận huyện.',
    sectionId: 'footer',
    canonical: 'https://thodienxanh.com/lien-he'
  },
  '/dat-lich': {
    title: 'Đặt Lịch Vệ Sinh Máy Lạnh Online Trong 30 Giây | Thợ Điện Xanh',
    description: 'Đặt lịch vệ sinh máy lạnh online nhanh chóng, chọn giờ linh hoạt, kỹ thuật viên có mặt đúng hẹn sau 30 phút.',
    action: 'open_booking',
    canonical: 'https://thodienxanh.com/dat-lich'
  },
  '/tra-cuu-don-hang': {
    title: 'Tra Cứu Đơn Hàng & Lịch Sử Đặt Dịch Vụ | Thợ Điện Xanh',
    description: 'Tra cứu tiến độ kỹ thuật viên, lịch sử đặt dịch vụ và quản lý mã giảm giá của bạn tại Thợ Điện Xanh.',
    action: 'open_account',
    canonical: 'https://thodienxanh.com/tra-cuu-don-hang'
  },
  '/admin': {
    title: 'Trang Quản Trị Hệ Thống | Thợ Điện Xanh',
    description: 'Bảng điều khiển quản trị hệ thống Thợ Điện Xanh.',
    action: 'open_admin',
    canonical: 'https://thodienxanh.com/admin'
  },
  '/admin/overview': {
    title: 'Tổng Quan Hệ Thống | Admin Thợ Điện Xanh',
    description: 'Tổng quan báo cáo doanh thu, đơn hàng và khách hàng.',
    action: 'open_admin',
    canonical: 'https://thodienxanh.com/admin/overview'
  },
  '/admin/bookings': {
    title: 'Quản Lý Đơn Đặt Lịch | Admin Thợ Điện Xanh',
    description: 'Danh sách và trạng thái xử lý đơn đặt lịch vệ sinh máy lạnh.',
    action: 'open_admin',
    canonical: 'https://thodienxanh.com/admin/bookings'
  },
  '/admin/reminders': {
    title: 'Quản Lý Lịch Nhắc Định Kỳ | Admin Thợ Điện Xanh',
    description: 'Danh sách khách hàng đăng ký nhắc bảo dưỡng định kỳ.',
    action: 'open_admin',
    canonical: 'https://thodienxanh.com/admin/reminders'
  },
  '/admin/users': {
    title: 'Quản Lý Khách Hàng & Thành Viên | Admin Thợ Điện Xanh',
    description: 'Danh sách tài khoản khách hàng, kỹ thuật viên và phân quyền admin.',
    action: 'open_admin',
    canonical: 'https://thodienxanh.com/admin/users'
  },
  '/admin/blog': {
    title: 'Quản Lý Bài Viết Blog | Admin Thợ Điện Xanh',
    description: 'Đăng và quản lý bài viết cẩm nang, mẹo hay trên website.',
    action: 'open_admin',
    canonical: 'https://thodienxanh.com/admin/blog'
  }
};

export class SEORouter {
  constructor() {
    this.currentPath = window.location.pathname || '/';
    this.articleModal = null;
    window.router = this;
    this.init();
  }

  init() {
    this.createArticleModal();
    this.interceptLinks();
    
    window.addEventListener('popstate', (e) => {
      this.handleRoute(window.location.pathname, false);
    });

    // Initial page route handle
    this.handleRoute(this.currentPath, false);
  }

  createArticleModal() {
    // Full-page article view is now in index.html (#blog-detail-view)
    // No modal creation needed — just wire up event listeners
    const copyBtn = document.getElementById('btn-copy-art-link');
    if (copyBtn) {
      copyBtn.addEventListener('click', () => {
        navigator.clipboard.writeText(window.location.href).then(() => {
          const txt = document.getElementById('copy-art-link-text');
          if (txt) { txt.textContent = '✓ Đã sao chép!'; setTimeout(() => { txt.textContent = 'Sao chép link'; }, 2000); }
        });
      });
    }
  }

  closeArticleView() {
    const detail = document.getElementById('blog-detail-view');
    const homepage = document.getElementById('homepage-sections');
    const footer = document.querySelector('footer');
    if (detail) detail.classList.add('hidden');
    if (homepage) homepage.classList.remove('hidden');
    if (footer) footer.classList.remove('hidden');
  }

  closeBlogListing() {
    const listing = document.getElementById('blog-listing-view');
    const homepage = document.getElementById('homepage-sections');
    const footer = document.querySelector('footer');
    if (listing) listing.classList.add('hidden');
    if (homepage) homepage.classList.remove('hidden');
    if (footer) footer.classList.remove('hidden');
  }

  showBlogListing() {
    import('./blog/blogView.js').then(({ showBlogListing }) => {
      showBlogListing();
    }).catch(err => {
      console.error('[Blog Load Error]', err);
    });
  }

  interceptLinks() {
    document.addEventListener('click', (e) => {
      const link = e.target.closest('a');
      if (!link) return;

      const href = link.getAttribute('href');
      if (!href) return;

      // Handle internal SEO paths starting with /
      if (href.startsWith('/') && !href.startsWith('//')) {
        e.preventDefault();
        this.navigateTo(href);
      } else if (href.startsWith('#')) {
        // Map old hashes to clean SEO URLs
        e.preventDefault();
        const cleanPath = href === '#hero' ? '/' : href === '#about' ? '/ve-chung-toi' : '/' + href.replace('#', '');
        this.navigateTo(cleanPath);
      }
    });
  }

  navigateTo(path, push = true) {
    if (push && path !== window.location.pathname) {
      window.history.pushState({}, '', path);
    }
    if (document.startViewTransition && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      document.startViewTransition(() => {
        this.handleRoute(path, true);
      });
    } else {
      this.handleRoute(path, true);
    }
  }

  handleRoute(path, isUserAction = true) {
    this.currentPath = path;

    // Check for Blog Post Route: /blog/:slug
    if (path.startsWith('/blog/')) {
      const rawSlug = path.replace('/blog/', '').replace(/\/$/, '');
      const slug = decodeURIComponent(rawSlug);
      const cleanSlug = slug.replace(/^-+|-+$/g, '');

      // Hide homepage immediately so it never flashes
      const homepage = document.getElementById('homepage-sections');
      if (homepage) homepage.classList.add('hidden');

      const blogs = store.getBlogs();
      const post = blogs[cleanSlug] || blogs[slug] || Object.values(blogs).find(b => {
        const bSlug = (b.slug || '').replace(/^-+|-+$/g, '');
        return b.slug === slug || bSlug === cleanSlug || b.id === slug || b.id === rawSlug || b.id === cleanSlug;
      });

      if (post) {
        const canonicalSlug = (post.slug || cleanSlug).replace(/^-+|-+$/g, '');
        if (typeof window !== 'undefined' && slug !== canonicalSlug && canonicalSlug) {
          window.history.replaceState({}, '', `/blog/${canonicalSlug}`);
        }
        this.showArticle(canonicalSlug, post);
        return;
      }

      // If blogs are still loading from Firestore (fresh browser session)
      import('./blog/blogView.js').then(({ ensureBlogDOM, showArticle }) => {
        ensureBlogDOM();
        const detail = document.getElementById('blog-detail-view');
        if (detail) detail.classList.remove('hidden');

        const titleEl = document.getElementById('page-art-title');
        if (titleEl) titleEl.textContent = 'Đang tải bài viết...';

        let timeoutId;
        const checkBlogLoaded = () => {
          const freshBlogs = store.getBlogs();
          const found = freshBlogs[cleanSlug] || freshBlogs[slug] || Object.values(freshBlogs).find(b => {
            const bSlug = (b.slug || '').replace(/^-+|-+$/g, '');
            return b.slug === slug || bSlug === cleanSlug || b.id === slug || b.id === rawSlug || b.id === cleanSlug;
          });
          if (found) {
            clearTimeout(timeoutId);
            window.removeEventListener('blogs-updated', checkBlogLoaded);
            const canonicalSlug = (found.slug || cleanSlug).replace(/^-+|-+$/g, '');
            this.showArticle(canonicalSlug, found);
          }
        };

        window.addEventListener('blogs-updated', checkBlogLoaded);

        // Fallback to 404 if post doesn't exist after timeout
        timeoutId = setTimeout(() => {
          window.removeEventListener('blogs-updated', checkBlogLoaded);
          const freshBlogs = store.getBlogs();
          const found = freshBlogs[cleanSlug] || freshBlogs[slug] || Object.values(freshBlogs).find(b => {
            const bSlug = (b.slug || '').replace(/^-+|-+$/g, '');
            return b.slug === slug || bSlug === cleanSlug || b.id === slug || b.id === rawSlug || b.id === cleanSlug;
          });
          if (!found) {
            import('./notFound.js').then(({ showNotFound }) => {
              showNotFound(`Bài viết "${cleanSlug}" không tồn tại hoặc đã bị xóa.`);
            });
            this.updateMetaTags({
              title: '404 — Bài Viết Không Tồn Tại | Thợ Điện Xanh',
              description: 'Bài viết bạn đang tìm kiếm không tồn tại hoặc đã bị gỡ bỏ.'
            });
          }
        }, 3500);
      }).catch(err => {
        console.error('[Blog Route Load Error]', err);
      });
      return;
    }

    // Check for Blog Listing Route: /blog
    if (path === '/blog') {
      const homepage = document.getElementById('homepage-sections');
      if (homepage) homepage.classList.add('hidden');
      import('./blog/blogView.js').then(({ showBlogListing }) => {
        showBlogListing();
      });
      import('./notFound.js').then(({ hideNotFound }) => hideNotFound()).catch(() => {});
      this.updateMetaTags(ROUTE_CONFIG['/blog']);
      return;
    }

    // Close full-page views if navigating away
    if (!path.startsWith('/blog')) {
      document.documentElement.classList.remove('route-blog');
      this.closeArticleView();
      this.closeBlogListing();
    } else {
      document.documentElement.classList.add('route-blog');
    }

    // Handle Admin Routes (/admin, /admin/blog, /admin/bookings, etc.)
    const isAdmin = path.startsWith('/admin');
    if (!isAdmin) {
      document.documentElement.classList.remove('admin-active');
      document.body.classList.remove('admin-active');
      if (typeof window.closeAdminPanel === 'function') {
        window.closeAdminPanel();
      }
      if (typeof window.ensureLandingDOM === 'function') {
        window.ensureLandingDOM();
      }
    } else {
      document.documentElement.classList.add('admin-active');
      document.body.classList.add('admin-active');
    }

    // Check for 404 Unmatched Route
    const isKnownRoute = !!ROUTE_CONFIG[path] || isAdmin;
    if (!isKnownRoute) {
      import('./notFound.js').then(({ showNotFound }) => {
        showNotFound();
      });
      this.updateMetaTags({
        title: '404 — Không Tìm Thấy Trang | Thợ Điện Xanh',
        description: 'Trang bạn đang tìm kiếm không tồn tại hoặc đã bị gỡ bỏ khỏi website Thợ Điện Xanh.'
      });
      return;
    }

    // Valid Route: Hide 404 if visible
    import('./notFound.js').then(({ hideNotFound }) => hideNotFound()).catch(() => {});

    const config = ROUTE_CONFIG[path] || (isAdmin ? ROUTE_CONFIG['/admin'] : ROUTE_CONFIG['/']);
    this.updateMetaTags(config);

    if (isAdmin) {
      const rawSub = path.replace('/admin', '').replace(/^\//, '') || 'overview';
      const targetTab = rawSub === 'dashboard' ? 'overview' : rawSub;
      import('./admin/admin.js').then(({ openAdminPanel, switchAdminTab }) => {
        openAdminPanel(targetTab);
        if (typeof switchAdminTab === 'function') {
          switchAdminTab(targetTab, false);
        }
      }).catch(err => {
        console.error('[Admin Load Error]', err);
      });
      return;
    }

    if (config.action === 'open_booking') {
      import('./booking/bookingModal.js').then(({ openBookingModal }) => {
        openBookingModal();
      }).catch(err => {
        console.error('[Booking Load Error]', err);
      });
    } else if (config.action === 'open_account') {
      import('./account/accountModal.js').then(({ openAccountModal }) => {
        openAccountModal('history');
      }).catch(err => {
        console.error('[Account Load Error]', err);
      });
    } else if (config.action === 'open_blog_listing') {
      import('./blog/blogView.js').then(({ showBlogListing }) => {
        showBlogListing();
      }).catch(err => {
        console.error('[Blog Load Error]', err);
      });
    } else if (config.sectionId) {
      const targetEl = document.getElementById(config.sectionId);
      if (targetEl && isUserAction) {
        targetEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }

  showArticle(slug, post) {
    this.updateMetaTags({
      title: `${post.title} | Thợ Điện Xanh`,
      description: post.description,
      canonical: `https://thodienxanh.com/blog/${slug}`
    });

    import('./blog/blogView.js').then(({ showArticle }) => {
      showArticle(slug, post);
    }).catch(err => {
      console.error('[Article Load Error]', err);
    });
  }

  updateMetaTags(config) {
    if (config.title) {
      document.title = config.title;
    }

    // Description
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc && config.description) {
      metaDesc.setAttribute('content', config.description);
    }

    // OG Title & Desc
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle && config.title) {
      ogTitle.setAttribute('content', config.title);
    }

    const ogDesc = document.querySelector('meta[property="og:description"]');
    if (ogDesc && config.description) {
      ogDesc.setAttribute('content', config.description);
    }

    // Canonical
    let canonicalTag = document.querySelector('link[rel="canonical"]');
    if (!canonicalTag) {
      canonicalTag = document.createElement('link');
      canonicalTag.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalTag);
    }
    if (config.canonical) {
      canonicalTag.setAttribute('href', config.canonical);
    }
  }
}
